<template lang="pug">
.d-flex.align-center.px-6.py-4
  search(
    v-model="model.filters.search"
    placeholder="Search user"
    @change="setQuery"
  ).search.pr-3

  v-select(
    item-value="name"
    item-text="name"
    v-model="model.filters.active_plan"
    solo
    dense
    flat
    menu-props="offset-y"
    :items="model.options.plans.list"
    :loading="model.options.plans.loading"
    :disabled="model.options.plans.loading"
    @change="setQuery"
    label="All plans"
    :clearable="true"
  ).filter

  v-select(
    item-value="value"
    item-text="title"
    v-model="model.filters.is_active"
    solo
    dense
    flat
    menu-props="offset-y"
    :items="model.options.statuses.list"
    :loading="model.options.statuses.loading"
    :disabled="model.options.statuses.loading"
    @change="setQuery"
    label="Status"
  ).filter
</template>

<script>
import {UsersFiltersModel} from "../core/models/UsersFiltersModel";

export default {
  components: {
    search: () => import("@/components/global/Search.vue"),
    filterAutocomplete: () => import('@/components/global/FilterAutocomplete.vue'),
  },
  data: () => ({
    model: {},
  }),
  created() {
    this.initFilters();
  },
  methods: {
    initFilters() {
      this.model = new UsersFiltersModel(this.$route.query);
      this.loadOptions();
    },

    async loadOptions() {
      await this.model.loadFilterOptions(this.$store)
    },

    async setQuery() {
      await this.$router.replace({query: { ...this.$route.query, ...this.model.getApiData()}})
      this.$emit('filterChanged')
    },
  }
}
</script>

<style lang="scss" scoped>
  .search::v-deep {
    .v-input__slot{
      &:before {
        display: none;
      }
    }
  }
  .filter {
    flex: 0 1 200px;
  }
  .v-input::v-deep {
    .v-input__slot {
      margin: 0;
    }
    .v-input__control {
      min-height: auto!important;
    }
    .v-text-field__details {
      display: none;
    }
  }
</style>
